var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdownDark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 8,
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.44362 7.58255C6.86029 7.58255 6.27695 7.35755 5.83529 6.91589L0.401953 1.48255C0.160286 1.24088 0.160286 0.840885 0.401953 0.599219C0.64362 0.357552 1.04362 0.357552 1.28529 0.599219L6.71862 6.03255C7.11862 6.43255 7.76862 6.43255 8.16862 6.03255L13.602 0.599219C13.8436 0.357552 14.2436 0.357552 14.4853 0.599219C14.727 0.840885 14.727 1.24088 14.4853 1.48255L9.05195 6.91589C8.61029 7.35755 8.02695 7.58255 7.44362 7.58255Z",
    fill: "#4A4B4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownDark);
export default __webpack_public_path__ + "static/media/dropdown_dark.db32a7a7486fc8283faa504bbec6bcf0.svg";
export { ForwardRef as ReactComponent };